import { trackEvent } from 'lib/ui-analytics';
import { getItineraryCardInfo } from 'lib/ui-analytics/utils';
import { PROD_CATEGORY, TEALIUM_BRAND, TRACKING_ACTION, TRACKING_COMPARE, TRACKING_INTERACTION } from '../Constants';
import { getInteraction } from '../utils';

export const utagCompareCheckbox = (cruise, index, resultsLength, checked, locale, brand) => {
  const interaction = createCompareInteraction(cruise, index, resultsLength, checked, locale, brand);
  trackEvent(interaction);
};

const createCompareInteraction = (cruise, index, resultsLength, checked, locale, brand) => {
  const { id, masterSailing, lowestPriceSailing } = cruise;

  return {
    'cardPosition': index + 1,
    'country': locale?.country,
    'currency': locale?.currency,
    'language': locale?.language,
    'departureDate': [lowestPriceSailing?.startDate],
    'siteSection': TEALIUM_BRAND[brand].siteSection,
    'pageName': TEALIUM_BRAND[brand].pageName,
    'eventType': TRACKING_ACTION.INTERACTION,
    'groupId': [cruise?.id],
    'itineraryCardInfo': getItineraryCardInfo(id, masterSailing, lowestPriceSailing),
    'interaction': getInteraction(index + 1, resultsLength, masterSailing, checked 
      ? TRACKING_INTERACTION.COMPARE.SELECT
      : TRACKING_INTERACTION.COMPARE.UNSELECT
    ),
    'prodSku': [masterSailing?.itinerary?.code],
    'productEvent': [checked 
      ? TRACKING_COMPARE.COMPARE_ADD
      : TRACKING_COMPARE.COMPARE_REMOVE
    ],
    'prodCategory': [PROD_CATEGORY.booking],
    'prodCost': [lowestPriceSailing.lowestStateroomClassPrice?.price?.value],
  }
}